import { useState } from "preact/hooks"
import AIInsightsForm from "./modals/AIInsightsForm"
import GetModals from "./modals/exploration"

export const Extra = ({displayOnly = false}) => {
	const [open, setOpen] = useState(true)

	return <AIInsightsForm open={open} displayOnly={displayOnly} onClose={() => setOpen(false)} />
}

export const backgrounds = {
	bgs: [
		"https://assets.swoogo.com/uploads/full/4607468-67293c292332a.png",
		"https://assets.swoogo.com/uploads/full/4590209-6721447025092.png",
		"https://assets.swoogo.com/uploads/full/4561458-6716b2a6300bd.png",
		"https://assets.swoogo.com/uploads/full/4590372-67214baff062d.png"
	],
	dts: [
		new Date("2024-11-10 00:00:00.000-05:00"),
		new Date("2024-11-11 08:00:00.000-05:00"),
		new Date("2024-11-12 08:00:00.000-05:00"),
		new Date("2024-11-12 19:00:00.000-05:00")
	],
	get(day = null) {
		if (day !== null) {
			if (!this.bgs[day]) return this.bgs[0]
			return {dt: this.dts[day], bg: this.bgs[day]}
		}

		const bg = this.dts.map((it, idx) => {
			return {dt: it, bg: this.bgs[idx]}
		}).filter(it => {
			return it.dt < new Date()
		})

		if (bg.length > 0) return bg.pop().bg
		
		return this.bgs[0]
	}
}

const modals = GetModals()

const TVs = [
	{
		height: "19.6%",
		left: "2%",
		top: "30%",
		width: "16.3%",
	},
	{
		width: "16.8%",
		height: "19.6%",
		left: "41.5%",
		top: "31%",
	},
	{
		height: "21.2%",
		left: "80.5%",
		top: "30%",
		width: "17.3%",
	},
	{
		width: "21.3%",
		height: "30.6%",
		left: "3%",
		top: "57%",
	},
	{
		width: "11.3%",
		height: "24.6%",
		left: "76%",
		top: "57%",
	},
	{
		width: "9.3%",
		height: "26.6%",
		left: "41%",
		top: "59%",
	}
].map((it, idx) => {
	if (!modals || !modals.tvs[idx]) return it
	if (modals.tvs[idx].length == 0) return it;

	const [Modal, props] = modals.tvs[idx]

	return {
		...it,
		modal: <Modal />,
		label: props.name,
		modalOverrides: {
			dismissStyle: props.dismiss,
			...(props.extras || {})
		}
	}
}).filter(it => it !== null)


export default {
	background: backgrounds.get(),
	links: [
		...TVs,
		{
			width: "13.1%",
			height: "8.2%",
			left: "43.3%",
			top: "89%",
			label: "Back to Atrium",
			href: "/atrium"
		}
	],
	extras: (new Date() > new Date("2024-11-11 08:00:00") && new Date() < new Date("2024-11-11 19:00:00")) && <Extra displayOnly />,
	name: "exploration-zone",
}
